import styled from "styled-components"
import React from "react"

const ImageGrid = ({category, products}) => {
    console.log("hello")
    // if(products.length) (products.map(product => console.log(product)))
    if(products.length) {
        return(
            <ImgWrapper>
                {products.filter(productCategory => productCategory.category === category).map((product) => {
                return (
                    
                    <Image key={product._id} {...product}/>
                    )
                })}
            </ImgWrapper>
        )
    }
    return <h2 style={{textAlign: 'center', padding: '5rem 1rem'}}>Loading...</h2>
}

const Image = React.memo(({category, image}) => {
    return (
        <section>
            <a target="_blank" rel="noreferrer"  href={image}>
            <img src={image} alt={category}/>
            </a>
        </section>
    )
})

const ImgWrapper = styled.section`
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    img {
        max-width: 250px;
        max-height: 250px;
        margin: 2rem;
    }
`

export default React.memo(ImageGrid)